var internalObjectKeys = require('../internals/object-keys-internal');
var enumBugKeys = require('../internals/enum-bug-keys');

// `Object.keys` method
// https://tc39.github.io/ecma262/#sec-object.keys
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/~/core-js/internals/object-keys.js
// module id = 510
// module chunks = 1